import { GridController, gridTpl } from '../../../common/grid/grid.controller';
import {GRID_FILTER_TOGGLE} from '../../../common/grid/grid.constants';
import { IDS } from './master-doc-list-action-id.constants';
import * as Actions from './master-doc-list.actions';

class MasterDocListGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, AuthService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.masterDocList;
        this.statePath = IDS.masterDocListGrid;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        this.autoload = false;
        this.defaultTitle = this.$filter('translate')('ACCREDITATION.MASTER_DOC_LIST.LIST.TAB');
        this.title = this.defaultTitle;
        // this.header = false;

        this.isAdmin = this.AuthService.getUser().type === 'Administrator';

        this.columnsDefault = [
            {title: '#',                                                            mapper: null},
            {title: this.$filter('translate')(`COMMON.DOCUMENT.NUMBER`),            mapper: 'doc_num'},
            {title: this.$filter('translate')(`COMMON.FIELD.TYPE`),                 mapper: 'typeColumn'},
            {title: 'Location',                                                     mapper: 'location'},
            {title: this.$filter('translate')(`COMMON.FIELD.NAME`),                 mapper: 'name'},
            {title: this.$filter('translate')(`COMMON.DATE.ISSUE_DATE`),            mapper: 'doc_date'},
            {title: this.$filter('translate')(`COMMON.DATE.DUE_DATE`),              mapper: 'due_date'},
            {title: this.$filter('translate')(`ACCREDITATION.COMMON.REQUIREMENTS`), mapper: 'requirementsColumn'},
            {title: this.$filter('translate')(`COMMON.FIELD.STATUS`),               mapper: 'status'},
        ];
        this.columns = this.columnsDefault.concat();

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);
        this.unsubscribeCustom = this.$ngRedux.connect(state => {
            // const masterDocListGrid = state.accreditation.masterDocList.masterDocListGrid;
            const selectedRequirement = state.accreditation.masterDocList.selectedRequirement;
            return {
                title: selectedRequirement?.nodeName || this.defaultTitle,
                // selectedHeadOfficeUuid:   masterDocListGrid.selectedHeadOfficeUuid,
                // overrideColumns:          masterDocListGrid.override.columns
            }
        }, {})(this);

        this.dataAction = this.fetchRcoDocumentAuditCycleStatusesGrid;

        this.buttons = [{
                class: 'btnGridAction',
                label: 'Download',
                callback: event => {
                    this.onDownload(event)
                }
            }];
        this.init();

        this.buttonsDefault = this.buttons.concat();
    }

    showAllColumns() {
        this.columns = this.columnsDefault.concat();
    }

    $onDestroy() {
        this.destroy();
        if(this.unsubscribeCustom)
            this.unsubscribeCustom();
    }
}

MasterDocListGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', '$filter', '$mdDialog', '$scope'];

export const masterDocListGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onDownload: '&',
        // onRemove: '&',
        // onDetach: '&',
    },
    controller: MasterDocListGridController,
    ...gridTpl
}
